import { preCheckPermissionsForAny } from "../checkPermissions.js";
export async function loadDynamicMenuItems(menu, runtimeContext, menuWithI18n, helpers) {
  if (menu.dynamicItems && menu.itemsResolve) {
    const overrideAppId = menu.app[0].appId;
    const newRuntimeContext = {
      ...runtimeContext,
      pendingPermissionsPreCheck: [...runtimeContext.pendingPermissionsPreCheck, preCheckPermissionsForAny(menu.itemsResolve)]
    };
    if (overrideAppId !== runtimeContext.app.id) {
      var _helpers$getStoryboar;
      newRuntimeContext.overrideApp = window.STANDALONE_MICRO_APPS ? menu.overrideApp : (_helpers$getStoryboar = helpers.getStoryboardByAppId(overrideAppId)) === null || _helpers$getStoryboar === void 0 ? void 0 : _helpers$getStoryboar.app;
      newRuntimeContext.appendI18nNamespace = menuWithI18n.get(menu);
    }
    const resolved = await helpers.resolveData({
      transform: "items",
      ...menu.itemsResolve
    }, newRuntimeContext);
    menu.items = resolved.items;
  }
}
//# sourceMappingURL=loadDynamicMenuItems.js.map